import { render, staticRenderFns } from "./CourseEnrollments.vue?vue&type=template&id=dff8ec62&scoped=true&"
import script from "./CourseEnrollments.vue?vue&type=script&lang=js&"
export * from "./CourseEnrollments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff8ec62",
  null
  
)

export default component.exports